import React, { useEffect, useState } from "react";
import BaseLayout from "../AnnouncementLayout";
import TopNavigation from "../../../components/TopNavigation";
import HeaderBaseLayout from "../AnnouncementHeader";
import EmptyData from "../../../components/EmptyDataScreen";
import ZoomModal from "../../../components/ModalZoom/Zoom";
import ApiUtils from "../../../utils/api_utils";
import moment from "moment";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import { Row, Col } from "react-bootstrap";
import { Base } from "../../../components/RootLayout";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import "./style.scss";

const AnnouncementDetail = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { getAnnouncementDetail, postLikeDetail } = props;
  const [data, setData] = useState({});
  const [isModal, setIsModal] = useState(false);

  const getData = async () => {
    const { status, data } = await getAnnouncementDetail(
      params?.announcementId
    );
    if (status == 200) {
      setData(data);
    } else {
      setData({});
    }
  };

  const handleClickDetailLikes = () => {
    navigate(PageRoutes.announcement + `/${params?.announcementId}` + "/likes");
  };

  const handleClickLike = async () => {
    const { status, data } = await postLikeDetail(params?.announcementId);
    if (status == 200) {
      getData();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const dataZoom = [
    {
      images: {
        img: {
          display: `${data?.display}`,
        },
      },
    },
  ];

  return (
    <>
      {!data.id ? (
        <Base>
          <TopNavigation
            titlePage="Announcement"
            toPath={-1}
            setBorder={true}
            showRightIcon={false}
            iconLeft={Assets.iconBack}
            iconRight={Assets.iconFilter}
          />
          <div className="noannouncement-spacing">
            <EmptyData
              title="There is no announcement"
              image={`${
                process.env.PUBLIC_URL + "/SKOR-Announcement-Empty.png"
              }`}
              imageStyle={{ width: "170px" }}
              bottomText="Stay tuned for company announcement here."
            />
          </div>
        </Base>
      ) : (
        <>
          <BaseLayout
            show_menu={false}
            isCustom={true}
            header={
              <HeaderBaseLayout
                src={Assets.iconBackWhite}
                isCustomPicture={true}
                picture={`url(${ApiUtils.validateImgUrl({
                  url: data?.display,
                })})`}
                onClick={() => navigate(PageRoutes.announcement)}
                onClickImageHeader={() => setIsModal(true)}
              />
            }
          >
            <div className="announcement-detail-wrapper">
              <span className="font-large">{data?.name}</span>
              <div className="mt-1">
                <span className="font-medium">
                  Posted on{" "}
                  {moment(data?.created).format("DD MMM YYYY, h:mm A")}
                </span>
              </div>
              <span>by {data?.creator?.name}</span>
              <div className="icon-like-wrapper mt-2">
                <img
                  src={Assets.iconLikeSolid}
                  alt="logo_image"
                  onClick={handleClickDetailLikes}
                />
                <span className="like-count">{data?.total_like}</span>
              </div>
              <div className="detail-desc">
                <span
                  className="desc"
                  dangerouslySetInnerHTML={{ __html: `${data?.description}` }}
                />
              </div>
              <Row>
                <Col xs={6} sm={6} md={6} className="button-like-wrapper">
                  <div
                    className="btn btn-block border-gray w-50 mr-1"
                    onClick={handleClickLike}
                  >
                    <img src={Assets.iconLikeSolid} alt="iconLikeSolid" />
                    &nbsp; <span className="">Like</span>
                  </div>
                </Col>
              </Row>
            </div>
          </BaseLayout>
          <ZoomModal
            open={isModal}
            data={dataZoom}
            toggle={() => setIsModal(!isModal)}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getAnnouncementDetail: dispatch.AnnouncementSM.getAnnouncementDetail,
  postLikeDetail: dispatch.AnnouncementSM.postLikeDetail,
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementDetail);
